if (!customElements.get('ikaya-horizontal-carousel')) {
  class IkayaHorizontalCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      if (!this.track) return;

      this.previousButton?.addEventListener('click', () => this.move(-1));
      this.nextButton?.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    }

    move(direction) {
      const firstCard = this.track.querySelector(':scope > *');
      const cardWidth = firstCard?.getBoundingClientRect().width || this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap) / (cardWidth + gap)));

      this.track.scrollBy({
        left: direction * (cardWidth + gap) * visibleCards,
        behavior: 'smooth'
      });
    }

    requestUpdate() {
      if (this.updateFrame) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.updateControls();
      });
    }

    updateControls() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const currentScroll = Math.abs(this.track.scrollLeft);

      if (this.previousButton) this.previousButton.disabled = currentScroll <= 2;
      if (this.nextButton) this.nextButton.disabled = currentScroll >= maxScroll - 2;
    }
  }

  customElements.define('ikaya-horizontal-carousel', IkayaHorizontalCarousel);
}
